import Icon1 from "@assets/icons/Icon";
import React from "react";
import { COMPANY_TYPE_LABELS as companyTypeLabels, HIDDEN_COMPANY_TYPES } from "@constants/partnerTypes";
import { Org } from "types/org";
import {
  MemberUser,
  MemberAssignmentItem,
} from "../blocks/MemberAssignmentBlock";
import { StatusBlock } from "../blocks/Status";
import { ProjectSummary, PartnerInfos, Broadcast, EmailSent, getProjectDisplayName } from "types";

const projectStatusDisplay: Record<
  string,
  { label: string; type: "success" | "info" | "warning" | "error" | "default" | "step" }
> = {
  not_started: { label: "En attente", type: "default" },
  in_progress: { label: "En cours", type: "info" },
  delivered: { label: "Livré", type: "success" },
  completed: { label: "Terminé", type: "success" },
  sav: { label: "SAV", type: "warning" },
};

export type Folder = {
  id: string;
  ref?: any;
  infos: {
    general: {
      name: string;
      num: string;
      city: string;
      date?: { seconds: number };
    };
    photo_facade?: { url: string; id: string };
    commercial_id?: string;
    comptability_id?: string;
  };
  creation_date: { seconds: number };
  status: string;
  results: {
    mandatory_checks_conforme?: number;
    mandatory_checks_available?: number;
  };
  archived?: boolean;
};

export function transformProjectsToTable(
  allfolders: ProjectSummary[],
  activetab: any = "current",
  orgData: Org | null = null,
  searchValue: string = "",
  orgUsers: MemberUser[] = [],
  currentUserId: string = "",
) {
  try {
    if (searchValue !== "") {
      allfolders = allfolders.filter((folder: ProjectSummary) =>
        folder.infos.general.name.includes(searchValue),
      );
    }

    if (activetab && activetab !== "all") {
      allfolders = allfolders.filter(
        (folder: ProjectSummary) => folder.status === activetab,
      );
    }

    // Define columns for DataGrid, customize based on your data structure
    const columns = [
      { field: "id", headerName: "ID", width: 300 },
      // {
      //   field: "photo",
      //   headerName: "Photo",
      //   width: 150,
      //   renderCell: (params: any) => {
      //     const photo = params.value;
      //     if (photo) {
      //       let retryAttempted = false; // Flag to prevent infinite retries
      //       return (
      //         <img
      //           src={photo.url}
      //           onError={async (e) => {
      //             if (retryAttempted) {
      //               console.error(
      //                 "Image refresh already attempted, skipping retry"
      //               );
      //               return;
      //             }
      //             retryAttempted = true;

      //             console.error("Image failed to load, refreshing URL...");
      //             const img = e.currentTarget as HTMLImageElement | null;
      //             if (!img) return;

      //             try {
      //               const token = await getOrRefreshFirebaseToken();
      //               const new_url = await refreshFileUrl(
      //                 photo.id,
      //                 token,
      //                 prefix
      //               );
      //               img.src = new_url;
      //               let ref = getRefFromId("folder", params.row.id);
      //               updateDocDataFieldApi(
      //                 ref!,
      //                 "infos.photo_facade",
      //                 {
      //                   url: new_url,
      //                 },
      //                 prefix
      //               );
      //               rows = rows.map((row: any) => {
      //                 if (row.id === params.row.id) {
      //                   return {
      //                     ...row,
      //                     photo: { url: new_url, id: photo.id },
      //                   };
      //                 }
      //                 return row;
      //               });
      //             } catch (err) {
      //               console.error("Failed to refresh image URL", err);
      //             }
      //           }}
      //           alt="Folder Facade"
      //           className="w-32 h-16 object-cover rounded-md"
      //         />
      //       );
      //     }
      //     return (
      //       <div className="w-32 h-16 bg-gray-100 rounded-md flex items-center justify-center">
      //         <Icon1 name="image" size={20} color="grey"></Icon1>
      //       </div>
      //     );
      //   },
      // },
      // { field: "num", headerName: "Numéro", width: 100 },

      {
        field: "name",
        headerName: "Nom",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => {
          const unseen: number = params.row.unseen_count || 0;
          return (
            <div
              className={`flex flex-row gap-2 items-center font-medium text-black h-6 ${
                params.row.all_blocked
                  ? "text-red-500  bg-red-100 rounded-full inline-flex  px-2 "
                  : ""
              }`}
            >
              {params.row.all_blocked && (
                <div className="">
                  <Icon1 name="warning" size={18} color="red"></Icon1>
                </div>
              )}
              <span className="truncate">{params.value}</span>
              {unseen > 0 && (
                <span
                  title={`${unseen} action${unseen > 1 ? "s" : ""} client non vue${unseen > 1 ? "s" : ""}`}
                  className="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-red-500 text-white text-h5 font-semibold"
                >
                  {unseen > 99 ? "99+" : unseen}
                </span>
              )}
            </div>
          );
        },
      },
      { field: "city", headerName: "Ville", width: 130 },
      {
        field: "commercial",
        headerName: "Commercial",
        width: 130,
        sortable: false,

        renderCell: (params: any) => {
          let user = params.value;
          return (
            <div className="flex flex-row gap-1 items-center">
              <MemberAssignmentItem
                currentUserId={user.id}
                memberName={user.name}
                memberColor={user.color}
                assignMemberToRole={() => {}}
                users={orgUsers}
              />
            </div>
          );
        },
      },
      {
        field: "conductor",
        headerName: "Conducteur",
        width: 130,
        sortable: false,

        renderCell: (params: any) => {
          let user = params.value;
          return (
            <div className="flex flex-row gap-1 items-center">
              <MemberAssignmentItem
                currentUserId={user.id}
                memberName={user.name}
                memberColor={user.color}
                assignMemberToRole={() => {}}
                users={orgUsers}
              />
            </div>
          );
        },
      },
      {
        field: "creation_date",
        headerName: "Creation",
        width: 150,
        renderCell: (params: any) => {
          // Customize color based on status value
          const date_int = params.value;

          const date = new Date(date_int);
          return (
            <div>
              {date.toLocaleString("fr-FR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },

      {
        field: "status",
        headerName: "Statut",
        width: 120,

        renderCell: (param: any) => {
          const status = param.value;
          const config = projectStatusDisplay[status] || {
            label: status,
            type: "default" as const,
          };
          return <StatusBlock type={config.type} label={config.label} />;
        },
      },
      {
        field: "current_step",
        headerName: "Étape",
        width: 180,
        sortable: false,

        renderCell: (param: any) => {
          const step = param.value;
          if (!step) return <span className="text-neutral-300">—</span>;
          return (
            <span className="text-h3 text-neutral-600 truncate" title={step}>
              {step}
            </span>
          );
        },
      },
      {
        field: "last_completed_cp",
        headerName: "Dernier contrôle",
        width: 180,
        sortable: false,

        renderCell: (param: any) => {
          const cp = param.value;
          if (!cp) return <span className="text-neutral-300">—</span>;
          return (
            <span className="text-h3 text-neutral-400 truncate" title={cp}>
              {cp}
            </span>
          );
        },
      },

      // Add more columns as needed
    ];

    // Create rows from the clients array
    let rows = allfolders.map((folder: ProjectSummary, index: number) => ({
      id: folder.id || index + 1, // Use client's ID or default index
      num: folder.infos.general.num || "ddd", // Use client's number or default
      name: getProjectDisplayName(folder)?.trim() || "", // Use SCI display name or contact names
      city: folder.infos.general.city || "", // Use client's type or default
      creation_date: folder.infos.general.creation_date.seconds * 1000 || 0,
      photo: folder.infos.general.photo_file?.url || "",
      status: folder.status || "ok", // Use client's status or default
      commercial:
        orgUsers.find((user) => user.id === folder.infos.team.commercial_id) ||
        {},
      conductor:
        orgUsers.find(
          (user) => user.id === folder.infos.team.conductor_id,
        ) || {},
      current_step: folder.current_step || "",
      last_completed_cp: folder.last_completed_cp || "",
      unseen_count: (() => {
        if (!currentUserId || !folder.unseen_by_user) return 0;
        const entry = folder.unseen_by_user[currentUserId];
        if (!entry) return 0;
        return (
          (entry.photos || 0) +
          (entry.documents || 0) +
          (entry.emails || 0) +
          (entry.signatures || 0)
        );
      })(),

      state: "ok",
    }));

    // Primary sort: projects with pending client actions float to the top,
    // descending by the total unseen count (so "5 new things" comes before
    // "2 new things"). Tiebreaker: alphabetical by project name.
    rows = rows.sort((a: any, b: any) => {
      const diff = (b.unseen_count || 0) - (a.unseen_count || 0);
      if (diff !== 0) return diff;
      return a.name
        .trim()
        .toLowerCase()
        .localeCompare(b.name.toLowerCase().trim());
    });

    return { rows, columns }; // Return rows and columns for the DataGrid
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformPartnersToTable(
  partners: PartnerInfos[],
  activeTab: string = "all",
  searchValue: string = "",
  onDecennaleClick?: (partnerId: string, partnerName: string) => void,
  onChargeClick?: (partnerId: string, partnerName: string) => void,
) {
  try {
    let filtered = partners;

    if (activeTab && activeTab !== "all") {
      filtered = filtered.filter((p) => p.company_types?.includes(activeTab));
    }

    if (searchValue !== "") {
      const search = searchValue.toLowerCase();
      filtered = filtered.filter(
        (p) =>
          p.display_name?.toLowerCase().includes(search) ||
          p.company_name?.toLowerCase().includes(search) ||
          p.role?.toLowerCase().includes(search),
      );
    }

    const columns = [
      {
        field: "company_name",
        headerName: "Entreprise",
        flex: 1,
        minWidth: 150,
        renderCell: (params: any) => (
          <div className="flex flex-row items-center gap-2 min-w-0">
            <span className="font-medium text-black truncate">{params.value}</span>
            {onChargeClick && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onChargeClick(
                    params.row.id,
                    params.row.company_name || params.row.display_name,
                  );
                }}
                className="shrink-0 inline-flex items-center justify-center w-6 h-6 p-0 leading-none rounded-full text-neutral-400 hover:text-blue-600 hover:bg-blue-50 transition-colors cursor-pointer"
                title="Voir la charge de cet artisan"
                aria-label="Voir la charge de cet artisan"
              >
                <span className="inline-flex items-center justify-center w-3.5 h-3.5 leading-none">
                  <Icon1 name="planning" size={14} />
                </span>
              </button>
            )}
          </div>
        ),
      },
      { field: "display_name", headerName: "Nom", width: 180 },
      {
        field: "company_types",
        headerName: "Type",
        width: 180,
        sortable: false,
        renderCell: (params: any) => {
          const types = (params.value as string[])?.filter(
            (t) => !HIDDEN_COMPANY_TYPES.has(t),
          );
          if (!types || types.length === 0) return null;
          return (
            <div className="flex flex-row gap-1 flex-wrap">
              {types.map((t: string) => (
                <StatusBlock
                  key={t}
                  type="info"
                  label={companyTypeLabels[t] || t}
                />
              ))}
            </div>
          );
        },
      },
      { field: "email", headerName: "Email", width: 200 },
      { field: "phone_number", headerName: "Téléphone", width: 140 },
      {
        field: "decennales_count",
        headerName: "Décennales",
        width: 90,
        renderCell: (params: any) => {
          const count = params.value as number;
          if (!onDecennaleClick) {
            if (!count) return null;
            return (
              <div className="flex flex-row items-center gap-1 text-neutral-500">
                <Icon1 name="file" size={16} />
                {count > 1 && <span className="text-h3 font-medium">{count}</span>}
              </div>
            );
          }
          if (!count) {
            return (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDecennaleClick(params.row.id, params.row.company_name || params.row.display_name);
                }}
                className="flex items-center gap-1 text-neutral-300 hover:text-blue-500 hover:bg-blue-50 rounded-md px-2 py-1 -mx-2 -my-1 transition-colors cursor-pointer"
                title="Ajouter une décennale"
              >
                <Icon1 name="plus" size={16} />
                <span className="text-h4">Ajouter</span>
              </button>
            );
          }
          return (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDecennaleClick(params.row.id, params.row.company_name || params.row.display_name);
              }}
              className="flex flex-row items-center gap-1 text-neutral-500 hover:text-blue-600 hover:bg-blue-50 rounded-md px-2 py-1 -mx-2 -my-1 transition-colors cursor-pointer"
              title="Gérer les décennales"
            >
              <Icon1 name="file" size={16} />
              {count > 1 && <span className="text-h3 font-medium">{count}</span>}
            </button>
          );
        },
      },
    ];

    const rows = filtered
      .map((p) => ({
        id: p.id,
        display_name: p.display_name || "",
        company_name: p.company_name || "",
        role: p.role || "",
        company_types: p.company_types || ["autre"],
        email: p.email || p.company_email || "",
        phone_number: p.phone_number || p.company_phone || "",
        decennales_count: p.decennales?.length || 0,
      }))
      .sort((a, b) =>
        a.display_name.toLowerCase().localeCompare(b.display_name.toLowerCase()),
      );

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformBroadcastsToTable(
  broadcasts: Broadcast[],
  activeTab: string = "all",
  searchValue: string = "",
) {
  try {
    let filtered = broadcasts;

    if (activeTab && activeTab !== "all") {
      filtered = filtered.filter((b) => b.status === activeTab);
    }

    if (searchValue !== "") {
      const search = searchValue.toLowerCase();
      filtered = filtered.filter(
        (b) =>
          b.title?.toLowerCase().includes(search) ||
          b.content?.toLowerCase().includes(search) ||
          b.author.display_name?.toLowerCase().includes(search),
      );
    }

    const columns = [
      {
        field: "title",
        headerName: "Titre",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => (
          <div className="font-medium text-black">{params.value}</div>
        ),
      },
      {
        field: "content",
        headerName: "Contenu",
        width: 250,
        renderCell: (params: any) => (
          <div className="text-neutral-500 truncate">
            {params.value?.length > 50
              ? params.value.slice(0, 50) + "..."
              : params.value}
          </div>
        ),
      },
      {
        field: "author",
        headerName: "Auteur",
        width: 140,
        renderCell: (params: any) => (
          <div
            className="rounded-full px-3 py-1 text-white font-medium text-h3 w-fit"
            style={{ backgroundColor: params.value?.color_tag || "#6B7280" }}
          >
            {params.value?.display_name}
          </div>
        ),
      },
      {
        field: "start_date",
        headerName: "Début",
        width: 130,
        renderCell: (params: any) => {
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </div>
          );
        },
      },
      {
        field: "end_date",
        headerName: "Fin",
        width: 130,
        renderCell: (params: any) => {
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </div>
          );
        },
      },
      {
        field: "status",
        headerName: "État",
        width: 120,
        renderCell: (params: any) => (
          <StatusBlock
            type={params.value === "active" ? "success" : "default"}
            label={params.value === "active" ? "Active" : "Inactive"}
          />
        ),
      },
    ];

    const rows = filtered
      .map((b) => ({
        id: b.id,
        title: b.title || "",
        content: b.content || "",
        author: b.author,
        start_date: b.start_date.seconds * 1000,
        end_date: b.end_date.seconds * 1000,
        status: b.status,
      }))
      .sort((a, b) => b.start_date - a.start_date);

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformEmailsSentToTable(
  sentEmails: EmailSent[],
  projects: ProjectSummary[],
  searchValue: string = "",
) {
  try {
    let filtered = sentEmails;

    if (searchValue !== "") {
      const search = searchValue.toLowerCase();
      filtered = filtered.filter((e) => {
        const projectName =
          projects
            .find((p) => p.id === e.project_id)
            ?.infos.general.name?.toLowerCase() || "";
        return (
          e.subject?.toLowerCase().includes(search) ||
          e.emails_to?.some((addr) => addr.toLowerCase().includes(search)) ||
          projectName.includes(search)
        );
      });
    }

    const columns = [
      {
        field: "subject",
        headerName: "Sujet",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => (
          <div className="font-medium text-black truncate">{params.value}</div>
        ),
      },
      {
        field: "recipients",
        headerName: "Destinataires",
        width: 200,
        renderCell: (params: any) => (
          <div className="text-neutral-500 truncate">{params.value}</div>
        ),
      },
      { field: "project_name", headerName: "Projet", width: 150 },
      {
        field: "date",
        headerName: "Date",
        width: 150,
        renderCell: (params: any) => {
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}{" "}
              {date.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },
    ];

    const rows = filtered
      .map((e) => ({
        id: e.id,
        subject: e.subject || "",
        recipients: e.emails_to?.join(", ") || "",
        project_name:
          projects.find((p) => p.id === e.project_id)?.infos.general.name || "",
        date: e.created_at.seconds * 1000,
      }))
      .sort((a, b) => b.date - a.date);

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}
